import { Injectable } from '@angular/core';
import { ListItem, PostStatus } from '@app/components/shared/rolling-hist-list/model/list-item';
import { SessionService } from '@app/services/session/session.service';
import { SessionKeys } from '@app/constants/session-keys';
import { defined } from '@app/fremework/functions';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RollingHistListService {
  private mapSubject = new BehaviorSubject<Map<string, ListItem<unknown>[]>>(null);
  public histListMap$: Observable<Map<string, ListItem<unknown>[]>> = this.mapSubject.asObservable();

  constructor(private sessionService: SessionService) {
    const histListMap = this.readHistListMap();
    this.mapSubject.next(histListMap);
  }

  public unshift(bucket: string, listItem: ListItem<unknown>): void {

    if (!defined(bucket) || !defined(listItem)) {
      return;
    }
    const histListMap = this.readHistListMap();
    if (histListMap?.has(bucket)) {
      const existingBucketList = histListMap.get(bucket);
      existingBucketList.unshift(listItem);

      if (existingBucketList.length > 3) {
        existingBucketList.pop();
      }

      histListMap.set(bucket, existingBucketList);

    } else {
      const bucketList = [listItem];
      histListMap.set(bucket, bucketList);
    }

    this.writeHistListMap(histListMap);
  }

  public setVerified(bucket: string, key: unknown): void {

    if (!defined(bucket) || !defined(key)) {
      return;
    }
    const histListMap = this.readHistListMap();

    if (histListMap.has(bucket)) {
      let existingBucketList = histListMap.get(bucket);
      const existingItem = existingBucketList.find(item => item.key === key);
      if (!existingItem) {
        return;
      }
      existingItem.verified = true;
      existingItem.status = 'verified';
      histListMap.set(bucket, existingBucketList);
      this.writeHistListMap(histListMap);
    }
  }

  public setStatus(bucket: string, id: string, status: PostStatus): void {
    if (!defined(bucket) || !defined(id)) {
      return;
    }
    const histListMap = this.readHistListMap();
    const item = histListMap.get(bucket)?.find(i => i.id === id);
    if (!item) {
      return;
    }
    item.status = status;
    item.verified = status === 'verified';
    this.writeHistListMap(histListMap);
  }

  private readHistListMap(): Map<string, ListItem<unknown>[]> {
    const json = this.sessionService.get(SessionKeys.histList);

    return defined(json)
      ? new Map<string, ListItem<unknown>[]>(JSON.parse(json))
      : new Map<string, ListItem<unknown>[]>();
  }

  private writeHistListMap(histListMap: Map<string, ListItem<unknown>[]>): void {
    this.sessionService.set(SessionKeys.histList, JSON.stringify(Array.from(histListMap.entries())));
    this.mapSubject.next(histListMap);
  }

}
